<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">喜报！腾讯云智能获选国家工信部工业互联网APP优秀解决方案</div>
      <div class="news-date">2023年2月14日</div>
      <div class="news-content">
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news17/news17_17.gif"/>
          </div>
        </div>
        <p>
          近日，工信部发布
          <span class="mark-text">《2022年工业互联网APP优秀解决方案名单》，</span>
          腾讯云智能凭借
          <span class="mark-text">“工业质检APP解决方案”</span>
          成功入选。作为腾讯云智能精心打磨而出的软硬一体AI外观质检解决方案，工业质检APP解决方案服务了众多制造企业的外观检测项目，为这些企业的产品质量检测自动化、智能化升级带来了质的飞跃：不仅检测能力全面超越人工水平，能够全天持续稳定工作，而且检测效率相较人工质检提升10倍，每年能为客户节省人力成本数千万元。
        </p>
        <p>据悉，申报解决方案需满足对行业和企业提质增效、转型升级发挥明显支撑引领作用；拥有自主知识产权等要求。入选的解决方案在项目实施创新性、产学研用协同创新能力、项目可推广性等维度都经过层层筛选，最终确定了191个解决方案为2022年工业互联网APP优秀解决方案。未来，各地也将在政策、资金、资源配套等方面加大对入选项目的支持力度，推动工业互联网APP的生态建设，以及解决方案在各地方、各行业的应用推广。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/newscenter/news32.jpeg"/>
          </div>
        </div>
        <p>
          入选《2022年工业互联网APP优秀解决方案名单》的“工业质检APP解决方案”是
          <span class="mark-text">腾讯云智能针对制造业自动外观质检难题，</span>
          在光学成像、算法、数据、工程等领域进行大量创新，精心打磨而出的
          <span class="mark-text">软硬一体AI外观质检解决方案。</span>
          通过光度立体解决方案、域适应迁移学习、无监督校准匹配等前沿技术的综合应用，不仅检测能力上达到业界领先的极低漏检，全面超越人工质检的水平，而且能全天持续稳定工作，解决人力水平难以标准化，状态不稳定，容易疲劳等问题。
        </p>
        <p>
          为成功打造该方案，腾讯云智能投入了经验丰富的产品开发团队，以及顶尖的人工智能算法研究团队进行攻坚研发。该方案从云边端三个不同维度出发，整合AI质检各环节的特殊要求，打造了
          <span class="mark-text">三位一体的全面工业AI协同解决方案：</span>
          云端的训练平台、边侧的传输协同及管理系统、以及端侧的工业质检一体机。
        </p>
        <p>
          <span class="mark-text">在云侧，</span>
          通过云端训练平台，能够提升AI质检模型的研发效率3倍以上，并将研发人员门槛大幅降低；
          <span class="mark-text">在边侧，</span>
          通过云边端协同的控制中转系统，建设了AI质检模型从研发到最终部署上线的中转协同系统，将AI质检模型部署至产线的速度提升10倍以上；
          <span class="mark-text">在端侧，</span>
          工业质检一体机能够以极大地适应性适配各种型号的产品外观检测光学成像及机械控制要求。
        </p>
        <p>在工业AI质检场景中，腾讯云智能已实现全面落地，打造了超过10个细分领域外观检测的解决方案，年累计交付超过100台外观检测设备，单一客户累计完成超过2000万件产品外观检测，为这些企业的产品质量检测自动化、智能化升级带来了质的飞跃。同时腾讯云智能携手合作伙伴，打造了面向多个场景的外观检测解决方案，助力富驰工业、宁德时代等客户每年节省超千万支出，助力企业实现降本增效。</p>
        <p>
          过去一年，腾讯云智能已经在金融、传媒、能源、交通、消费电子等诸多领域，围绕决策智能、服务智能、研发智能和生活智能，构建产品工具和解决方案，助力“以人为本”的价值创新。未来，腾讯云智能将继续沿着做厚平台、做精应用、做深行业、做广生态的战略方向，助力各行各业拥有大算力、易开发、能落地的云端智能平台，
          <span class="mark-text">让AI成为产业升级的“贴心”助手。</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News32',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content {
  margin: 0 auto;
  .image-panel {
    max-width: 667px;
    text-align: center;
    img {
      max-width: 667px;
    }
    span {
      font-size: 12px;
      color: #858585;
    }
  }
  .end-divide {
    width: 120px;
    height: 2px;
    margin: 20px auto;
    background: #0152d9;
  }
  .download-article-wrap {
    margin: 0 auto;
    padding: 5px 3px;
    border: 3px solid rgb(1, 82, 217);
    font-family: PingFangSC-light;
    .download-article {
      padding: 5px 10px;
      border-left: 1px solid rgb(1, 82, 217);
      border-right: 1px solid rgb(1, 82, 217);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News32.vue